import { sendGTMEvent } from '@next/third-parties/google'

export type GtmFooterLinksClickedType = {
  action: string
  category: string
}

export const gtmFooterLinksClicked = ({
  action,
  category,
}: GtmFooterLinksClickedType) => {
  if (!action || !category) return

  const uuid = crypto.randomUUID()

  sendGTMEvent({
    event: 'sho_footer_link_clicked',
    action,
    category,
    event_id: uuid,
  })
}
